import React from 'react';
import {Col, Row} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from "../../../../divider-block";
import i18n from '../../../../../i18n';

export default function MainDataFields({ stepFields, setFields, getFieldErrors, edit = false }) {
	let dividerStyle = {
		margin: "15px 0px 45px 0px",
		display: "block",
		clear: "both",
		width: "100%",
		minWidth: "100%",
		height: "1px",
	};

    return (
        <>
          <Row gutter={[16,24]}>
            <Col lg={8} sm={24}>
              <InputField
                name="name"
                title={i18n.t('constants.formFields.Name')}
                label="Organizacijos pavadinimas"
                required={true}
                value={stepFields.name}
                setValue={(value) => {setFields({...stepFields, name: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="fullName"
                  title={i18n.t('constants.formFields.FullName')}
                  label="Pilnas pavadinimas organizacijos"
                  required={true}
                  value={stepFields.fullName}
                  setValue={(value) => {setFields({...stepFields, fullName: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>

			<span className="divider-label">Kontaktiniai duomenys</span>
			<DividerBlock style={dividerStyle} />

          <Row gutter={[16,24]}>
            <Col lg={8} sm={24}>
              <InputField
                name="firstName"
                title={i18n.t('constants.formFields.FirstName')}
                label="Vardas"
                required={true}
                value={stepFields.firstName}
                setValue={(value) => {setFields({...stepFields, firstName: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                name="secondName"
                title={i18n.t('constants.formFields.SecondName')}
                label="Pavardė"
                required={true}
                value={stepFields.secondName}
                setValue={(value) => {setFields({...stepFields, secondName: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                name="patronymic"
                title={i18n.t('constants.formFields.Patronymic')}
                label="Antras vardas"
                required={true}
                value={stepFields.patronymic}
                setValue={(value) => {setFields({...stepFields, patronymic: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16,24]}>
            <Col lg={8} sm={24}>
              <InputField
                  name="phone"
                  title={i18n.t('constants.legalEntityDataAliases.Phone')}
                  label="Telefonas"
                  required={true}
                  value={stepFields.phone}
                  setValue={(value) => {setFields({...stepFields, phone: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="email"
                  label="Email"
                  required={true}
                  value={stepFields.email}
                  setValue={(value) => {setFields({...stepFields, email: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
		  <span className="divider-label">Banko duomenis</span>
		  <DividerBlock style={dividerStyle} />
          <Row gutter={[16,24]}>
            <Col lg={8} sm={24}>
              <InputField
                  name="bankName"
                  title={i18n.t('constants.legalEntityDataAliases.BankName')}
                  label="Bankas"
                  required={true}
                  value={stepFields.bankName}
                  setValue={(value) => {setFields({...stepFields, bankName: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="accountNumber"
                  title={i18n.t('constants.legalEntityDataAliases.AccountNumber')}
                  label="Sąskaitos numeris"
                  required={true}
                  value={stepFields.accountNumber}
                  setValue={(value) => {setFields({...stepFields, accountNumber: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="swift"
                  label="SWIFT"
                  required={true}
                  value={stepFields.swift}
                  setValue={(value) => {setFields({...stepFields, swift: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
			<span className="divider-label">Juridinio asmens duomenys</span>
			<DividerBlock style={dividerStyle} />
          <Row gutter={[16,24]}>
            <Col lg={8} sm={24}>
              <InputField
                  name="position"
                  title={i18n.t('constants.legalEntityDataAliases.PositionStr')}
                  label="Pasirašiusiosios pozicija"
                  required={true}
                  value={stepFields.position}
                  setValue={(value) => {setFields({...stepFields, position: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="registerNumber"
                  title='Регистрационный номер'
                  label="Registracijos numeris"
                  required={true}
                  value={stepFields.registerNumber}
                  setValue={(value) => {setFields({...stepFields, registerNumber: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="legalNumber"
                  title={i18n.t('modals.modalEditLegalEntityNew.fields.legalNumber.title')}
                  label="Asmens kodas verslininko / fizinio asmens"
                  required={true}
                  value={stepFields.legalNumber}
                  setValue={(value) => {setFields({...stepFields, legalNumber: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                name="legalReason"
                title={i18n.t('constants.shipperCompanyDataAliases.legalReason')}
                label="Veiksmo pagrindas"
                required={true}
                value={stepFields.legalReason}
                setValue={(value) => {setFields({...stepFields, legalReason: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
			<span className="divider-label">Adresus</span>
			<DividerBlock style={dividerStyle} />
          <Row gutter={[16,24]}>
            <Col lg={24} sm={24}>
              <InputField
                  name="address"
                  title={i18n.t('constants.formFields.RegAddress')}
                  label="Adresas"
                  required={true}
                  value={stepFields.address}
                  setValue={(value) => {setFields({...stepFields, address: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={24} sm={24}>
              <InputField
                  name="mailingAddress"
                  title={i18n.t('constants.formFields.MailingAddress')}
                  label="El. pašto adresas"
                  required={true}
                  value={stepFields.mailingAddress}
                  setValue={(value) => {setFields({...stepFields, mailingAddress: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
        </>
    );
}
